import React from "react";

const ReportItemList = ({ data, setYear, activeYear }) => {
  const renderClass = (item) => {
    let _data = data.data[[activeYear]]?.half_year;
    let _item = item?.half_year;

    return _item === _data ? "active" : "";
  };

  return (
    <div className="report-item-list">
      <ul>
        {data?.data?.map(
          (year, i) =>
            year.half_year && (
              <li
                key={i}
                onClick={() => setYear && setYear(i)}
                className={renderClass(year)}
              >
                {year.half_year}
              </li>
            )
        )}
      </ul>
    </div>
  );
};

export default ReportItemList;
